import { render, staticRenderFns } from "./LeaveAllowanceBreakdownInput.vue?vue&type=template&id=60186bb2"
import script from "./LeaveAllowanceBreakdownInput.vue?vue&type=script&lang=js"
export * from "./LeaveAllowanceBreakdownInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports